define("linkinbio/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('page', {
      path: '/:slug'
    }, function () {
      this.route('blocks', function () {
        this.route('button_list');
        this.route('email_collection', function () {
          this.route('block', {
            path: '/:block_id'
          });
        });
        this.route('header', {
          path: '/profile'
        });
        this.route('feed');
        this.route('featured_banner');
        this.route('featured_media');
        this.route('multi_item_banner', function () {
          this.route('item', {
            path: '/:item_id'
          });
        });
        this.route('social_link_list');
        this.route('reorder');
      });
      this.route('style');
      this.route('analytics');
      this.route('settings', function () {
        this.route('manage_account');
        this.route('seo');
        this.route('utm');
      });
      this.route('embed');
      this.route('invalid', {
        path: '/*path'
      });
    });
    this.route('setup');
    this.route('restricted');
  });
});